import { useTranslation } from '@thoughtspot/i18n';
import { Modal } from '@thoughtspot/radiant-react/widgets/modal';
import React from 'react';
import { TranslationKeys as TranslationKeysHelpCust } from '../../application-settings/help-customization/constants';
import { TranslationsKeys as backupStorageTranslationskeys } from '../backup-storage/common/constants';
import { TranslationsKeys } from './constants';
const getModalConfigs = (t) => ({
    security_back: {
        title: t(TranslationsKeys.SECURITY_BACK_CONFIRMATION_MODAL_TITLE),
        isOpen: true,
        dismissButton: {
            text: t(TranslationsKeys.SECURITY_BACK_CONFIRMATION_MODAL_CANCEL_BTN),
        },
        confirmButton: {
            text: t(TranslationsKeys.SECURITY_BACK_CONFIRMATION_MODAL_LEAVE_BTN),
        },
        body: t(TranslationsKeys.SECURITY_BACK_CONFIRMATION_MODAL_CONTENT),
    },
    security_delete: {
        title: t(TranslationsKeys.DELETE_SSL_CONFIRMATION_MODAL_TITLE),
        isOpen: true,
        dismissButton: {
            text: t(TranslationsKeys.DELETE_SSL_CONFIRMATION_MODAL_CANCEL_BTN),
        },
        confirmButton: {
            text: t(TranslationsKeys.DELETE_SSL_CONFIRMATION_MODAL_CONFIRM_BTN),
        },
        body: t(TranslationsKeys.DELETE_SSL_CONFIRMATION_MODAL_CONTENT),
    },
    smtp_delete: {
        title: t(TranslationsKeys.DELETECONFIRMATION_MODAL_TITLE),
        isOpen: true,
        dismissButton: {
            text: t(TranslationsKeys.CANCEL_BUTTON),
        },
        confirmButton: {
            text: t(TranslationsKeys.MODAL_DELETE_BTN),
        },
        body: t(TranslationsKeys.DELETECONFIRMATION_MODAL_CONTENT),
    },
    smtp_back: {
        title: t(TranslationsKeys.BACK_MODAL_TITLE),
        isOpen: true,
        dismissButton: {
            text: t(TranslationsKeys.MODAL_CANCEL_BTN),
        },
        confirmButton: {
            text: t(TranslationsKeys.BACK_MODAL_LEAVE),
        },
        body: t(TranslationsKeys.MODAL_CONTENT),
    },
    smtp_hostNotReachable: {
        title: t(TranslationsKeys.HOST_NOTREACHABLE_TITLE),
        isOpen: true,
        confirmButton: {
            text: t(TranslationsKeys.CLOSE_BUTTON),
        },
        body: t(TranslationsKeys.HOST_NOTREACHABLE_MESSAGE),
    },
    backupAndStorage_back: {
        title: t(TranslationsKeys.BACK_MODAL_TITLE),
        isOpen: true,
        dismissButton: {
            text: t(TranslationsKeys.MODAL_CANCEL_BTN),
        },
        confirmButton: {
            text: t(TranslationsKeys.BACK_MODAL_LEAVE),
        },
        body: t(TranslationsKeys.MODAL_CONTENT),
    },
    backupAndStorage_deleteNas: {
        title: t(backupStorageTranslationskeys.NAS_MODAL_TITLE),
        isOpen: true,
        dismissButton: {
            text: t('CANCEL'),
        },
        confirmButton: {
            text: t('DELETE'),
        },
        body: t(backupStorageTranslationskeys.NAS_MODAL_CONTENT),
    },
    backupAndStorage_deleteSnapshot: {
        title: t(backupStorageTranslationskeys.SNAPSHOT_MODAL_TITLE),
        isOpen: true,
        dismissButton: {
            text: t('CANCEL'),
        },
        confirmButton: {
            text: t('DELETE'),
        },
        body: t(backupStorageTranslationskeys.SNAPSHOT_MODAL_CONTENT),
    },
    help_customization_delete: {
        title: t(TranslationKeysHelpCust.HELP_CUSTOMIZATION_DELETEITEM_MODAL_TITLE),
        isOpen: true,
        dismissButton: {
            text: t(TranslationsKeys.CANCEL_BUTTON),
        },
        confirmButton: {
            text: t(TranslationsKeys.MODAL_DELETE_BTN),
        },
        body: t(TranslationKeysHelpCust.HELP_CUSTOMIZATION_DELETEITEM_MODAL_CONTENT),
    },
    help_customization_reset: {
        title: t(TranslationKeysHelpCust.HELP_CUSTOMIZATION_RESETTODEFAULT_MODAL_TITLE),
        isOpen: true,
        dismissButton: {
            text: t(TranslationsKeys.CANCEL_BUTTON),
        },
        confirmButton: {
            text: t(TranslationKeysHelpCust.HELP_CUSTOMIZATION_RESETTODEFAULT),
        },
        body: t(TranslationKeysHelpCust.HELP_CUSTOMIZATION_RESETTODEFAULT_MODAL_CONTENT),
    },
    saml_delete: {
        title: t(TranslationsKeys.REMOVE_CONFIRMATION_TEXT),
        isOpen: true,
        dismissButton: {
            text: t(TranslationsKeys.CANCEL_BUTTON),
        },
        confirmButton: {
            text: t(TranslationsKeys.MODAL_DELETE_BTN),
        },
        body: t(TranslationsKeys.SAML_REMOVE_CONFIRM_DESC),
    },
    activeDirectory_delete: {
        title: t(TranslationsKeys.REMOVE_CONFIRMATION_TEXT),
        isOpen: true,
        dismissButton: {
            text: t(TranslationsKeys.CANCEL_BUTTON),
        },
        confirmButton: {
            text: t(TranslationsKeys.MODAL_DELETE_BTN),
        },
        body: t(TranslationsKeys.AD_REMOVE_CONFIRM_DESC),
    },
});
export const CreateModal = ({ pageName = '', action = '', onDismiss = () => {
}, onConfirm = () => {
}, }) => {
    const { t } = useTranslation();
    const modalBaseConfig = getModalConfigs(t)[`${pageName}_${action}`] || undefined;
    const modalConfig = {
        ...modalBaseConfig,
        onDismiss: onDismiss ||
            (() => {
            }),
        confirmButton: {
            ...modalBaseConfig.confirmButton,
            onConfirm: onConfirm ||
                (() => {
                }),
        },
    };
    if (modalConfig) {
        return (React.createElement(Modal, { title: modalConfig.title, isOpen: modalConfig.isOpen, dismissButton: modalConfig.dismissButton, onDismiss: modalConfig.onDismiss, size: 'small', confirmButton: modalConfig.confirmButton },
            React.createElement("div", null, modalConfig.body)));
    }
    return React.createElement(React.Fragment, null);
};
//# sourceMappingURL=create-modal.js.map